/*
 * @Description: 图片素材相关接口
 * @Author: trae.ai
 * @Date: 2025-03-15
 */
import request from '../request';

// 获取分类和格式
export function getCategoryAndFormat() {
  return request('/image/category/list', {
    method: 'GET'
  })
}

// 收藏图片素材
export function collectImage(imageId) {
  return request('/image/collect', {
    method: 'GET',
    params: { imageId }
  })
}

// 取消收藏图片素材
export function cancelCollectImage(imageId) {
  return request('/image/collect/cancel', {
    method: 'GET',
    params: { imageId }
  })
}

// 获取图片素材详情
export function getImageDetail(imageId) {
  return request('/image/detail', {
    method: 'GET',
    params: { imageId }
  })
}

// 获取下载链接
export function getDownloadUrl(imageId) {
  return request('/image/download/url', {
    method: 'GET',
    params: { imageId }
  })
}

// 获取图片素材列表
export function getImageList(params) {
  return request('/image/list', {
    method: 'GET',
    params
  })
}

// 获取图片会员价格
export function getPriceList() {
  return request('/price', {
    method: 'GET',
  })
}

// 获取收藏图片列表
export function getCollectImageList(params) {
  return request('/image/collection/list', {
    method: 'GET',
    params
  })
}

// 获取当前id是否图片素材
export function getIsImage(id) {
  return request(`/image/${id}`, {
    method: 'GET',
  })
}

// 获取我的订单图片列表
export function getOrderImageList(params) {
  return request('/image/order/list', {
    method: 'GET',
    params
  })
}

// 获取颜色列表
export function getColorList() {
  return request('/image/color/list', {
    method: 'GET'
  })
}

// 获取尺寸列表
export function getImageSizeList() {
  return request('/image/size/list', {
    method: 'GET'
  })
}
